import { PlayerSlotInterface, SlotGroupInterface } from "@/types";
import PlayerSlot from "./PlayerSlot";
import LotterySlotInterface from "../types/LotterySlotInterface";

export default class SlotGroup implements Partial<SlotGroupInterface> {
  public description: string = "";
  public name: string = "Alpha";
  public hasDefaultName: boolean = true;
  public playerSlots: PlayerSlotInterface[] = [];
  public lotterySlots: LotterySlotInterface[] = [];

  constructor (
    name: string,
    description: string = "",
    playerSlots: PlayerSlotInterface[] = []
  ) {
    this.name = name;
    this.description = description;

    this.playerSlots = [];
    playerSlots.forEach((slot) => {
      this.playerSlots.push(new PlayerSlot(slot.name, slot.description, slot.leader, slot.lottery, slot.tags));
    });
  }
}
